import { CalEventFieldType } from '../constants/cal-event-field-type.js';
import { validateTemplateFieldValue } from './validate-template-field-value.js';
export function ruleDefaultConfigError(rule, fields) {
    const target = fields.find((candidate) => candidate.id === rule.targetFieldId);
    if (target?.type === CalEventFieldType.ENTITY_REF)
        return `Rule value for "${rule.targetFieldId}" must default to the acting user — a reference field cannot default to a fixed record.`;
    if (!target?.config)
        return undefined;
    const configError = validateTemplateFieldValue(target.type, target.config, rule.value);
    return configError && `Rule value for "${rule.targetFieldId}": ${configError}`;
}
//# sourceMappingURL=rule-default-config-error.js.map